module.exports = __webpack_public_path__ + "static/media/aws.bde4ea40.svg";